import { Component, h } from 'preact';

class PymChild extends Component {
  constructor() {
    super();

    this.child = new pym.Child({ polling: 1500 });
  }

  componentDidMount() {
    this.child.sendHeight();
  }

  componentDidUpdate() {
    this.child.sendHeight();
  }

  render({ className }) {
    return <div class={className}>{this.props.children}</div>;
  }
}

export default PymChild;



// WEBPACK FOOTER //
// ./componentsV2/PymChild.js